const DEFAULT_STATE = null;

const GET_ERROR_STATUS = 'GET_ERROR_STATUS';
export const getErrorStatus = () => dispatch => {
  dispatch({ type: GET_ERROR_STATUS });
};

const RESET_ERROR = 'RESET_ERROR';
export const resetError = () => dispatch => {
  dispatch({ type: RESET_ERROR });
};

const errorReducer = (state = DEFAULT_STATE, action) => {
  if (action.error) {
    return action.error;
  }

  if (action.type === 'RESET_ERROR') {
    return null;
  }

  return state;
};

export const selectError = state => state.error;

export default errorReducer;
